import React from "react";
import { Amplify } from 'aws-amplify';
import { Authenticator, useAuthenticator, View } from "@aws-amplify/ui-react";
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom'

import '../styling/amplify.css';

import COGNITO_CONFIG from '../config/cognito.json'
import API_GATEWAY_CONFIG from '../config/apiGateway.json'
import S3_CONFIG from '../config/s3.json'

import AuthLandingPage from "./AuthLandingPage";
import NoAuthLandingPage from "./NoAuthLandingPage";
import { AuthWrapper } from "./CustomAuth/AuthWrapper";
import { PublicLayout } from './Layout/PublicLayout'
import AERMODtrialPage from "./Models/AERMODPreview/AERMODtrialPage";
import SCICHEMtrialPage from "./Models/SCICHEMPreview/SCICHEMtrialPage";


Amplify.configure({
  Auth: {
    region: COGNITO_CONFIG.REGION,
    userPoolId: COGNITO_CONFIG.USER_POOL_ID,
    userPoolWebClientId: COGNITO_CONFIG.USER_POOLL_WEB_CLIENT_ID,
    identityPoolId: COGNITO_CONFIG.IDENTITY_POOL_ID
  },
  API: {
    endpoints: [
      {
        name: API_GATEWAY_CONFIG.NAME,
        endpoint: API_GATEWAY_CONFIG.API_GATEWAY_URL,
        region: API_GATEWAY_CONFIG.REGION
      },
    ]
  },
  Storage: {
    bucket: S3_CONFIG.BUCKET,
    region: S3_CONFIG.REGION,
    httpOptions: {
      timeout: 600000,
      connectTimeout: 120000
    }
  }
});

const Root = () => {
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator(context => [context.authStatus])
  if (authStatus === 'authenticated') {
    navigate('/')
  }
  
  return (
    <PublicLayout>
      <NoAuthLandingPage />
    </PublicLayout>
  )
}

function AuthenticatorWrapper() {
  const navigate = useNavigate();

  return (
    <Authenticator
      hideSignUp
      loginMechanisms={['username']}
    >
      {({ user }) => {
        if (user) {
          navigate('/');
        }
        return null;
      }}
    </Authenticator>
  );
}

export default function App() {
  return (
    <Authenticator.Provider>
      <View>
      <BrowserRouter>
        <Routes>
          { /* Public Routes */}
          <Route path='/home' element={<Root />} />
          <Route path='/login' element={<AuthenticatorWrapper/>} />
          <Route path='/AERMODPreview' element={
            <PublicLayout>
              <AERMODtrialPage/>  
            </PublicLayout>
          }/>
          <Route path='/SCICHEMPreview' element={
            <PublicLayout>
              <SCICHEMtrialPage/>
            </PublicLayout>
          }/>

          {/* Protected Routes */}
          <Route path="/*" element={
            <AuthWrapper>
                <AuthLandingPage/>
            </AuthWrapper>
          } />
        </Routes>
      </BrowserRouter>
      </View>
    </Authenticator.Provider>
  )
}
